/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RiskAssessmentBranchItemDto } from '../models/RiskAssessmentBranchItemDto';
import type { RiskAssessmentBranchItemDtoPagedListData } from '../models/RiskAssessmentBranchItemDtoPagedListData';
import type { RiskAssessmentGroupDto } from '../models/RiskAssessmentGroupDto';
import type { RiskAssessmentStatus } from '../models/RiskAssessmentStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RiskAssessmentService {

  /**
   * @param branchId
   * @returns RiskAssessmentBranchItemDtoPagedListData Success
   * @throws ApiError
   */
  public static getApiRiskAssessment(
    branchId: number,
  ): CancelablePromise<RiskAssessmentBranchItemDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/risk-assessment',
      query: {
        'BranchId': branchId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id
   * @returns RiskAssessmentBranchItemDto Success
   * @throws ApiError
   */
  public static getApiRiskAssessment1(
    id: number,
  ): CancelablePromise<RiskAssessmentBranchItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/risk-assessment/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putApiRiskAssessment(
    id: number,
    formData?: {
      Status?: RiskAssessmentStatus;
      ValidTillDate?: string;
      IsRequiredDocuments?: boolean;
      DeleteLinkIds?: Array<number>;
      NewFiles?: Array<Blob>;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/risk-assessment/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param branchId
   * @param riskItem
   * @returns RiskAssessmentBranchItemDto Success
   * @throws ApiError
   */
  public static getApiRiskAssessment2(
    branchId: number,
    riskItem: number,
  ): CancelablePromise<RiskAssessmentBranchItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/risk-assessment/{branchId}/{riskItem}',
      path: {
        'branchId': branchId,
        'riskItem': riskItem,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId
   * @param riskItemId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postApiRiskAssessment(
    branchId: number,
    riskItemId: number,
    formData?: {
      Status?: RiskAssessmentStatus;
      ValidTillDate?: string;
      IsRequiredDocuments?: boolean;
      DeleteLinkIds?: Array<number>;
      NewFiles?: Array<Blob>;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/risk-assessment/{branchId}/{riskItemId}',
      path: {
        'branchId': branchId,
        'riskItemId': riskItemId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns RiskAssessmentGroupDto Success
   * @throws ApiError
   */
  public static getApiRiskAssessmentGroups(): CancelablePromise<Array<RiskAssessmentGroupDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/risk-assessment/groups',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static postApiRiskAssessmentGroups(
    requestBody?: Array<RiskAssessmentGroupDto>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/risk-assessment/groups',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
